import { get } from '..';

interface GetMetricProps {
  metric: string,
  range: { start, end },
  interval?: string,
}

const GetMetricHappyScoreData = ({ metric, range, interval }: GetMetricProps) => {
  let url: string = `happy-score/by-metric?metric=${metric}`;
  url += `&from=${new Date(range.start).toISOString()}&to=${new Date(range.end).toISOString()}`;
  if (interval) url += `&interval=${interval}`;

  return get(url).then((data) => {
    if (data?.isError) return null;
    return data.filter((point) => new Date(point.date) <= new Date());
  }).catch(() => null);
};

export default GetMetricHappyScoreData;
